/**
 * @file Displays an error message with optional retry functionality.
 */
import React from 'react';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry }) => {
    return (
        <div style={{ 
            color: 'red', 
            padding: '20px', 
            border: '1px solid #ffcdd2', 
            borderRadius: '4px', 
            backgroundColor: '#ffebee',
            textAlign: 'center'
        }}>
            <p style={{ margin: '0 0 10px 0' }}>{message}</p>
            {onRetry && (
                <button 
                    onClick={onRetry}
                    style={{
                        backgroundColor: '#f44336',
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '14px'
                    }}
                >
                    Intentar de nuevo
                </button>
            )}
        </div>
    );
};

export default ErrorMessage;
